
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Quill from "quill";
import { quillEditor } from "vue-quill-editor";


var Font = Quill.import("formats/font");

Font.whitelist = null;

Quill.register(Font, true);

// --------------------

var SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = null;

Quill.register(SizeStyle, true);

// --------------------

var Link = Quill.import("formats/link");

class MyLink extends Link {
	static create(value) {
		let node = super.create(value.value);
		let href = this.sanitize(value.value);
		node.setAttribute("href", href);

		if (value.targetBlank === false) {
			node.removeAttribute("target");
		}
    return node;
	}
}

Quill.register(MyLink);

// --------------------

// --------------------

let BlockEmbed = Quill.import('blots/block/embed');

class ImageBlot extends BlockEmbed {

//<img v-if="isImgx" crossorigin="anonymous"
// 	src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
// :data-srcset="imgxSrcSet"
// :alt="basic.alt"
// 	data-sizes="auto"
// :data-src="imgxSrc"
// :class="['lazyload',advanced.cssClasses]"
// :width="width"
// :id="advanced.cssId"
// :height="height" :style="style">

  static create(value) {
	  function imgxSrc(src, width, height) {
		  src = src.replace("https://", "").replace("http://", "").replace("//", "")
		  if (src.indexOf("images.funnelish.com") >= 0)
			  src = src.replace("images.funnelish.com", "fnsh.imgix.net");

		  return `//${src}?auto=compress,format&fit=scale&w=${width}&h=${height}`;
	  }

		let w = value.width || '100%'; let h = value.height || 'auto';

    let node = super.create();
	  node.setAttribute('src', imgxSrc(value.url, w, h));
	  node.setAttribute('crossorigin', 'anonymous');
		node.setAttribute('width', w);
		node.setAttribute('height', h);

	if(value.display) node.style.display = value.display;
	if(value.float) node.style.float = value.float;
	if(value.margin) node.style.margin = value.margin;

    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute('src'),
	  width: node.getAttribute('width'),
	  height: node.getAttribute('height'),
	  display: node.style.display || false,
	  float: node.style.float || false,
	  margin: node.style.margin || false,
    };
  }
}
ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';

Quill.register(ImageBlot)

// --------------------
const Parchment = Quill.import('parchment');

const alignConfig = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['left', 'right', 'center', 'justify']
};

let AlignAttribute = new Parchment.Attributor.Attribute('align', 'align', alignConfig);
let AlignClass = new Parchment.Attributor.Class('align', 'ql-align', alignConfig);
let AlignStyle = new Parchment.Attributor.Style('align', 'text-align', alignConfig);

Parchment.register(AlignAttribute);
Parchment.register(AlignClass);
Parchment.register(AlignStyle);

export default quillEditor;
</script>
